import React from 'react';
import Hero from '../components/home/Hero';
import OpeningHours from '../components/home/OpeningHours';
import About from '../components/home/About';
import ServicePackages from '../components/home/ServicePackages';
import WorkGallery from '../components/home/WorkGallery';

const Home = () => {
  return (
    <div>
      <Hero />
      <OpeningHours />
      <About />
      <ServicePackages />
      <WorkGallery />
     
    </div>
  );
};

export default Home;